import React from 'react'
import { Field } from 'redux-form'

import FilterCheckbox from '@cinch/oxd-components/filter-checkbox/src'
import { setToString } from '@cinch/oxd-utils/form/src'

import CheckboxGroup from './components/checkbox-group.component'
import { getInputValue } from './utils/checkbox-group.utils'

interface Option {
  label: string
  value: string | number
}

interface CheckboxGroupProps {
  options: Option[]
  name: string
  onReset?: () => any
}

const FilterCheckboxGroup: React.FC<CheckboxGroupProps> = ({ onReset = () => null, ...props }) => {
  const value: any[] = []
  const [selectedItems, updateSelectedItems] = React.useState(value)

  const onChange = (input: any, values: any) => {
    updateSelectedItems(values)
    if (input && input.onChange) {
      input.onChange(values.join())
    }
  }

  const handleAnyChange = () => {
    if (onReset) {
      onReset()
    }
    updateSelectedItems([])
  }

  const getFieldGroup = (fieldData: { input: { value: any } }) => {
    const { input } = fieldData
    if (input && input.value && input.value !== selectedItems.join()) {
      updateSelectedItems(getInputValue(input))
    }

    return <CheckboxGroup data={fieldData} onChange={onChange} />
  }

  return (
    <>
      <FilterCheckbox
        label="Any"
        key="Any"
        name="Any"
        value="Any"
        checked={selectedItems.length === 0}
        onChange={handleAnyChange}
        isCustomCheckbox={true}
      />
      <Field key="group" onReset={onReset} {...props} component={getFieldGroup} format={setToString} />
    </>
  )
}

export default FilterCheckboxGroup
